// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3xcUF","colMin":"styles_colMin__3ns5y","colCheckbox":"styles_colCheckbox__RhTLl"};